import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { SAFETY_CHECKLIST_API } from "../apiRoutes";
import axiosAuth from "@/services/axiosAuth";

interface UseGetSafetyChecklistByProjectProps {
  projectId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getSafetyChecklistByProject = async (projectId: string) => {
  return await axiosAuth.get(`${SAFETY_CHECKLIST_API}/project/${projectId}`);
};

const useGetSafetyChecklistByProject = ({
  projectId,
  queryParams,
}: UseGetSafetyChecklistByProjectProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["safety-checklist", projectId],
    queryFn: () => getSafetyChecklistByProject(projectId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetSafetyChecklistByProject;
